<br>
<div class="row">
    <div class="col-xs-12">
        <div class="main-box">
            <div class="main-box-body clearfix" style="padding:20px">
                <div *ngIf="vendors.vendorDtoList?.length>0" class="col-xs-12">
                    <form role="form" class="form-horizontal" name="vendorForm" novalidate>
                        <div class="form-group">
                            <label for="role" class="col-sm-1 control-label">Vendors: </label>
                        </div>
                        <div class="row" style="display: flex; justify-content: center; ">
                            <div class="col-xs-10">
                                <div class="col-xs-4" *ngFor="let vendor of vendors.vendorDtoList"
                                     style="margin:10px 0px 10px 0px">
                                    <div class="name">
                                        <div class="checkbox-nice">
                                            <input type="checkbox" class="access"
                                                   id="{{vendor.vendorName}}"
                                                   [disabled]="readOnlyForClientOrBU"
                                                   [(ngModel)]="vendor.isSelected"
                                                   name="vendorSelected_{{vendor.vendorName}}"/>
                                            <label class="oneemfontsize"
                                                   [ngClass]="{'disable-element': readOnlyForClientOrBU}"
                                                   for="{{vendor.vendorName}}">{{vendor.vendorName}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="!(vendors.vendorDtoList?.length>0)" class="col-xs-12">
                    No Vendors Available.
                </div>
            </div>
        </div>
    </div>
</div>
